import '../App.css';
import React, { useState, useEffect } from 'react';
import { Button, ActionButton, Text, Tooltip, TooltipTrigger } from '@adobe/react-spectrum';
import Delete from '@spectrum-icons/workflow/Delete';
import { defaultTheme, Provider } from '@adobe/react-spectrum';
import Highlighter from './Highlighter';
import { logHighlightEvent } from '../logging';

function SelectionToolbar({ ...properties }) {
    const BUTTON_STATES = {
        highlighter: <Delete size="S" />,
        cursor: <Highlighter size="S" />,
    };

    var range = properties.range[0].props.range;

    function mapRange(value, originalMin, originalMax, newMin, newMax) {
        let mappedValue = newMin + ((value - originalMin) * (newMax - newMin)) / (originalMax - originalMin);
        mappedValue = Math.min(newMax, Math.max(newMin, mappedValue));
        return mappedValue;
    }

    function addHighlight() {
        var index = properties.highlights.indexOf(range);
        var newHighlight = properties.highlights[index];
        newHighlight.highlight = true;
        properties.setHighlights(properties.highlights.toSpliced(index, 1).concat(newHighlight));
        var newWordCount = properties.countNumWords(range.text);
        properties.setWordCount(properties.wordCount + newWordCount);
    }

    function deleteHighlight() {
        var index = properties.highlights.indexOf(range);
        var snappedRange = properties.highlights[index];
        let newHighlights = properties.highlights.toSpliced(index, 1);

        var deletedWordCount = properties.countNumWords(range.text);
        properties.setWordCount(properties.wordCount - deletedWordCount);

        if (properties.recalculateBlurWhenDeleted) {
            let opacityAmount = mapRange(properties.wordCount - deletedWordCount, properties.targetWordCount + 1, 650, 0, 1);
            properties.setOpacityAmount(opacityAmount);
        }

        properties.setHighlights(newHighlights);

        let log = {}
        if (properties.experiment === "exp1-tweaking") {
            log = {
                type: "delete",
                timestamp: Date.now(),
                workerId: properties.workerId,
                participantId: properties.participantId,
                experiment: properties.experiment,
                condition: properties.condition,
                pass: properties.pass,
                newWordCount: (properties.wordCount - deletedWordCount),
                snappedRange: snappedRange
            }

            logHighlightEvent(log);
        }

        else if (properties.experiment === "exp2-highlights" || properties.experiment === "exp3-withinHighlights") {
            log = {
                type: "delete",
                timestamp: Date.now(),
                workerId: properties.workerId,
                participantId: properties.participantId,
                experiment: properties.experiment,
                condition: properties.condition,
                newWordCount: (properties.wordCount - deletedWordCount),
                snappedRange: snappedRange
            }
            // console.log(log)
            logHighlightEvent(log);
        }
    }

    function previewAddHighlight() {
        var potentialWordCount = properties.countNumWords(range.text);
        properties.setShadowWordCount(properties.wordCount + potentialWordCount);
    }

    function stopPreviewAddHighlight() {
        properties.setShadowWordCount(properties.wordCount);
    }


    function previewDeleteHighlight() {
        var potentialWordCount = properties.countNumWords(range.text);
        properties.setProgressWordCount(properties.wordCount - potentialWordCount);
    }

    function stopPreviewDeleteHighlight() {
        properties.setProgressWordCount(properties.wordCount);
    }


    function mouseEnter() {
        if (properties.selectedTool === 'highlighter') {
            previewDeleteHighlight();
        }
        else if (properties.selectedTool === 'cursor') {
            previewAddHighlight();
        }
    }

    function mouseLeave() {
        if (properties.selectedTool === 'highlighter') {
            stopPreviewDeleteHighlight();
        }
        else if (properties.selectedTool === 'cursor') {
            stopPreviewAddHighlight();
        }
    }

    function mouseClick() {
        if (properties.selectedTool === 'highlighter') {
            deleteHighlight();
        }
        else if (properties.selectedTool === 'cursor') {
            addHighlight();
            properties.updateShowToolbar(false);
        }
    }

    return (
        <div className="blackButton"
            onClick={mouseClick}
            onMouseEnter={mouseEnter}
            onMouseLeave={mouseLeave}
            style={range.showToolbar ?
                {
                    visibility: 'visible',
                    position: 'absolute',
                    top: 'calc(0% - 30px)',
                    left: '100%',
                    cursor: 'pointer',
                    zIndex: 999,
                } :
                {
                    visibility: 'hidden',
                    position: 'absolute',
                }}
        >

            {BUTTON_STATES[properties.selectedTool]}
        </div>
    );
}

export default SelectionToolbar;